import React from 'react';
import { Switch, FormControlLabel, alpha } from '@mui/material';
import PropTypes from 'prop-types';
import { MobergTheme, getColors } from '../MobergThemes/MobergColors';

function MobergToggle(props) {
    const {
        checked = false,
        onChange,
        name,
        disabled = false,
        label,
        style,
        labelPlacement = 'end', // Default value set to 'end'
        theme = MobergTheme.BLUE
    } = props;

    const containerStyle = {
        marginLeft: '10px',
        marginRight: '10px',
        ...style,
    };

    const colors = getColors(theme)

    return (
        <FormControlLabel
            sx={{ "& .MuiFormControlLabel-label": { color: "var(--color-text-primary)" } }}
            control={
                <Switch
                    checked={checked}
                    onChange={onChange}
                    name={name}
                    disabled={disabled}
                    sx={{
                        "& .MuiSwitch-track": {
                            backgroundColor: "#bbb",
                            opacity: 0.5,
                        },

                        "& .MuiSwitch-switchBase": {
                            "&.Mui-checked": {
                                color: colors.main,
                                "&:hover": {
                                    backgroundColor: alpha(colors.main, 0.2),
                                },
                                "& + .MuiSwitch-track": {
                                    backgroundColor: colors.noFill.active,
                                    opacity: 1,
                                },
                            },
                        },
                    }}
                />
            }
            label={label}
            labelPlacement={labelPlacement}
            style={containerStyle}
        />
    );
}

MobergToggle.propTypes = {
    checked: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    color: PropTypes.oneOf(['primary', 'secondary', 'default', 'error', 'info', 'success', 'warning']),
    name: PropTypes.string,
    disabled: PropTypes.bool,
    label: PropTypes.node,
    style: PropTypes.object,
    labelPlacement: PropTypes.oneOf(['end', 'start', 'top', 'bottom']),
};

export default MobergToggle;